export const BUTTON_RADIUS = '25px'
export const BLOCK_RADIUS = '10px'

export const MENU_Z_INDEX = 10
export const Z_INDEX_DEFAULT = 1